import React from "react";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {FlagsProvider} from "@atlaskit/flag";
import MenuBar from "./components/MenuBar";
import SingleMenuConfiguration from "./components/admin/SingleMenuConfiguration";
import {jwtstore} from "./api/JWTStore";
import OverviewPage from "./components/admin/OverviewPage";
import {LicenseCheckInfo} from "./components/LicenceCheckInfo";
import SettingsPage from "./components/admin/SettingsPage";
import {Forbidden} from "./Forbidden";
import {
    PAGE_ADMIN_MENU_OVERVIEW,
    PAGE_ADMIN_MENU_SETTINGS,
    PAGE_ADMIN_SINGLE_MENU_CONFIG,
    PAGE_GENERAL_SINGLE_MENU_CONFIG,
    PARAM_APP_MENU_CONFIG_MENU_KEY
} from "navigation-common/types/pages-constants";

import {ReviewBanner} from "./components/banner/ReviewBanner";
import {CqlModal} from "./components/cql-modal/CqlModal";

export class AppRouter extends React.Component<{}, {}> {

    constructor(props: Readonly<{}> | {}) {
        super(props);
        let jwt = (new URLSearchParams(window.location.search)).get('jwt');
        if (jwt) {
            jwtstore.jwt = jwt;
        }
    }

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/navigation/show-menu" element={
                        <MenuBar menu={undefined} changeToggle={false}/>
                    }/>
                    <Route path={PAGE_ADMIN_MENU_OVERVIEW.url} element={
                        <FlagsProvider>
                            <LicenseCheckInfo/>
                            <ReviewBanner/>
                            <OverviewPage/>
                        </FlagsProvider>
                    }/>
                    <Route path={`${PAGE_ADMIN_SINGLE_MENU_CONFIG.url}/:${PARAM_APP_MENU_CONFIG_MENU_KEY}`} element={
                        <FlagsProvider>
                            <LicenseCheckInfo/>
                            <ReviewBanner/>
                            <SingleMenuConfiguration/>
                        </FlagsProvider>
                    }/>
                    <Route path={PAGE_ADMIN_MENU_SETTINGS.url} element={
                        <FlagsProvider>
                            <LicenseCheckInfo/>
                            <ReviewBanner/>
                            <SettingsPage/>
                        </FlagsProvider>
                    }/>
                    <Route path={`${PAGE_GENERAL_SINGLE_MENU_CONFIG.url}/:${PARAM_APP_MENU_CONFIG_MENU_KEY}`} element={
                        <FlagsProvider>
                            <LicenseCheckInfo/>
                            <ReviewBanner/>
                            <SingleMenuConfiguration/>
                        </FlagsProvider>
                    }/>
                    <Route path={`/navigation/cql-results-content`} element={
                        <CqlModal/>
                    }/>
                    <Route path="/navigation/403" element={
                        <Forbidden/>
                    }/>
                </Routes>
            </BrowserRouter>
        );
    }
}
